import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';

export const Cell = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	height: 24px;
`;

export const PopoverContent = styled.div`
	display: flex;
	flex-direction: column;
	padding: 10px;
	box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.25);
`;

export const CategoryLine = styled.div`
	font-size: 12px;
`;

export const CategoryLevel = styled.span`
	color: ${colors.grey5};
`;
export const CategoryTitle = styled.span`
	color: ${colors.grey8};
`;

export const CategoryIconWrapper = styled.div`
	height: 100%;
	width: 100%;
	svg {
		margin-top: -1px;
	}
`;
